import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=42e953d6&scoped=true&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e953d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
